import { PageHeader } from "../components/PageHeader";

/**
 * Shared legal page shell. Uses the site's standard PageHeader (dark hero,
 * champagne accents) followed by a single light-bone content section with
 * the site's standard body typography.
 *
 * Content is passed in as JSX so each page keeps its structure explicit
 * while sharing chrome, typography, and spacing with the rest of the site.
 */
export function LegalPage({ eyebrow = "Legal", title, highlightWord, subtitle, lastUpdated, matchLandingHero = false, children }) {
  return (
    <main className="min-h-screen bg-bone" data-testid={`legal-page-${eyebrow.toLowerCase()}`}>
      <PageHeader
        eyebrow={eyebrow}
        headline={title}
        highlightWord={highlightWord}
        subheadline={subtitle}
        compact={!matchLandingHero}
        matchLandingHero={matchLandingHero}
      />

      <section className="surface-day py-16 lg:py-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-8">
          {lastUpdated && (
            <p className={`font-mono text-[11px] uppercase tracking-[0.18em] mb-10 ${matchLandingHero ? "text-champ-light-day" : "text-champagne"}`}>
              Last updated · {lastUpdated}
            </p>
          )}
          <div className={`legal-body${matchLandingHero ? " legal-body-light-accents" : ""}`} data-testid="legal-body">
            {children}
          </div>
        </div>
      </section>
    </main>
  );
}
